import firebase from 'firebase'
import 'firebase/firestore'

// firebase init goes here
const config = {
  apiKey: "AIzaSyDqvp6O1HlbDci5iPqZphAzHgJDz81Yxd8",
  authDomain: "lore-eights.firebaseapp.com",
  databaseURL: "https://lore-eights.firebaseio.com",
  projectId: "lore-eights",
  storageBucket: "lore-eights.appspot.com",
  messagingSenderId: "456449262128"
}
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// date issue fix according to firebase
const settings = {
}

db.settings(settings)

// firebase collections
const usersCollection = db.collection('users')
const cardsCollection = db.collection('cards')
const decksCollection = db.collection('decks')

export {
    db,
    auth,
    currentUser,
    usersCollection,
    cardsCollection,
    decksCollection
  }



// WEBPACK FOOTER //
// ./src/firebaseConfig.js